// extracted by mini-css-extract-plugin
export var icon = "_46-1";
export var subtext = "_46-0";